import React from 'react';

export default function NoSelectionCzr({ width = '119', height = '142' }: { width?: string; height?: string }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 119 142"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="Empty Message">
      <rect
        x="117"
        y="63"
        width="77"
        height="115"
        rx="3"
        transform="rotate(90 117 63)"
        fill="white"
        stroke="#01172E"
        strokeWidth="4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.4501 23H78.7274L69.5852 32.1422L60.443 23H59.7203L50.5781 32.1422L41.436 23H40.7132L31.5711 32.1422L22.6214 23.1925C20.5304 23.791 19 25.7168 19 28V123C19 125.761 21.2386 128 24 128H95C97.7614 128 100 125.761 100 123V28C100 26.0348 98.8663 24.3344 97.2172 23.5172L88.5923 32.1422L79.4501 23Z"
        fill="white"
      />
      <path d="M26.5 29.5L22.5 26.5V125.5H26.5V29.5Z" fill="#E5E5E5" />
      <mask id="path-4-inside-1_215_1057" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M79.4501 23H78.7274L69.5852 32.1422L60.443 23H59.7203L50.5781 32.1422L41.436 23H40.7132L31.5711 32.1422L22.6214 23.1925C20.5304 23.791 19 25.7168 19 28V123C19 125.761 21.2386 128 24 128H95C97.7614 128 100 125.761 100 123V28C100 26.0348 98.8663 24.3344 97.2172 23.5172L88.5923 32.1422L79.4501 23Z"
        />
      </mask>
      <path
        d="M79.4501 23L82.2785 20.1716L81.107 19H79.4501V23ZM78.7274 23V19H77.0705L75.8989 20.1716L78.7274 23ZM69.5852 32.1422L66.7568 34.9706L69.5852 37.799L72.4136 34.9706L69.5852 32.1422ZM60.443 23L63.2715 20.1716L62.0999 19H60.443V23ZM59.7203 23V19H58.0634L56.8919 20.1716L59.7203 23ZM50.5781 32.1422L47.7497 34.9706L50.5781 37.799L53.4066 34.9706L50.5781 32.1422ZM41.436 23L44.2644 20.1716L43.0928 19H41.436V23ZM40.7132 23V19H39.0564L37.8848 20.1716L40.7132 23ZM31.5711 32.1422L28.7426 34.9706L31.5711 37.799L34.3995 34.9706L31.5711 32.1422ZM22.6214 23.1925L25.4498 20.364L23.7847 18.6989L21.5207 19.3469L22.6214 23.1925ZM97.2172 23.5172L98.9933 19.9332L96.4197 18.6578L94.3888 20.6888L97.2172 23.5172ZM88.5923 32.1422L85.7638 34.9706L88.5923 37.799L91.4207 34.9706L88.5923 32.1422ZM79.4501 19H78.7274V27H79.4501V19ZM75.8989 20.1716L66.7568 29.3137L72.4136 34.9706L81.5558 25.8284L75.8989 20.1716ZM72.4136 29.3137L63.2715 20.1716L57.6146 25.8284L66.7568 34.9706L72.4136 29.3137ZM60.443 19H59.7203V27H60.443V19ZM56.8919 20.1716L47.7497 29.3137L53.4066 34.9706L62.5487 25.8284L56.8919 20.1716ZM53.4066 29.3137L44.2644 20.1716L38.6075 25.8284L47.7497 34.9706L53.4066 29.3137ZM41.436 19H40.7132V27H41.436V19ZM37.8848 20.1716L28.7426 29.3137L34.3995 34.9706L43.5417 25.8284L37.8848 20.1716ZM34.3995 29.3137L25.4498 20.364L19.793 26.0209L28.7426 34.9706L34.3995 29.3137ZM21.5207 19.3469C17.7592 20.4235 15 23.8844 15 28H23C23 27.5492 23.3016 27.1584 23.7221 27.038L21.5207 19.3469ZM15 28V123H23V28H15ZM15 123C15 127.971 19.0294 132 24 132V124C23.4477 124 23 123.552 23 123H15ZM24 132H95V124H24V132ZM95 132C99.9706 132 104 127.971 104 123H96C96 123.552 95.5523 124 95 124V132ZM104 123V28H96V123H104ZM104 28C104 24.4568 101.952 21.3993 98.9933 19.9332L95.4411 27.1013C95.7806 27.2695 96 27.6128 96 28H104ZM94.3888 20.6888L85.7638 29.3137L91.4207 34.9706L100.046 26.3457L94.3888 20.6888ZM91.4207 29.3137L82.2785 20.1716L76.6217 25.8284L85.7638 34.9706L91.4207 29.3137Z"
        fill="#01172E"
        mask="url(#path-4-inside-1_215_1057)"
      />
      <path
        d="M83.3885 54.3519H35.7231C34.7713 54.3519 34 53.6015 34 52.6759C34 51.7504 34.7713 51 35.7231 51H83.3885C84.3403 51 85.1116 51.7504 85.1116 52.6759C85.1118 53.6015 84.3405 54.3519 83.3885 54.3519Z"
        fill="#01172E"
      />
      <path
        d="M83.3885 64.3519H35.7231C34.7713 64.3519 34 63.6015 34 62.6759C34 61.7504 34.7713 61 35.7231 61H83.3885C84.3403 61 85.1116 61.7504 85.1116 62.6759C85.1118 63.6015 84.3405 64.3519 83.3885 64.3519Z"
        fill="#01172E"
      />
      <circle
        cx="92"
        cy="27"
        r="17.3419"
        transform="rotate(-45 92 27)"
        fill="white"
        stroke="#01172E"
        strokeWidth="3.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M89.334 39.8894C97.9249 39.8894 104.889 32.9251 104.889 24.3342C104.889 20.8322 103.732 17.6004 101.779 15.0006C105.557 17.8385 108 22.3565 108 27.4452C108 36.0361 101.036 43.0004 92.445 43.0004C87.3561 43.0004 82.838 40.5567 80.0001 36.7788C82.6 38.732 85.8318 39.8894 89.334 39.8894Z"
        fill="#F5F5F5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M82.8809 26.9728C82.8809 26.1519 83.5464 25.4864 84.3674 25.4864H100.314C101.135 25.4864 101.8 26.1519 101.8 26.9728C101.8 27.7937 101.135 28.4592 100.314 28.4592H84.3674C83.5464 28.4592 82.8809 27.7937 82.8809 26.9728Z"
        fill="#1BC47D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.3405 36.4324C91.5196 36.4324 90.8541 35.7669 90.8541 34.9459L90.8541 18.9996C90.8541 18.1787 91.5196 17.5132 92.3405 17.5132C93.1614 17.5132 93.8269 18.1787 93.8269 18.9996L93.8269 34.9459C93.8269 35.7669 93.1614 36.4324 92.3405 36.4324Z"
        fill="#1BC47D"
      />
    </svg>
  );
}
